import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import ImportScreen from './ImportScreen'
import SurveyPreview from './SurveyPreview'
import ReviewIframe from './ReviewIframe'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((_theme) => ({}))

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={ value !== index }
      id={ `simple-tabpanel-${index}` }
      aria-labelledby={ `simple-tab-${index}` }
      { ...other }
    >
      { value === index && (
        <Box p={ 2 } style={{ minHeight: 550 }}>
          <Paper elevation={ 1 }>
            <Box p={ 3 }>
              { children }
            </Box>
          </Paper>
        </Box>
      ) }
    </Typography>
  )
}

export default function ManageSurveys(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    console.log('new tab value', newValue);
    setValue(newValue)
  }

  return (
    <>
    {
      props.userProfile === 'administrator'
        ? (
          <>
            <AppBar position="static">
              <Tabs
                value={ value }
                onChange={ handleChange }
                aria-label="Importação de Questionários"
              >
                <Tab label="Importar" />
                <Tab label="Questionário" />
              </Tabs>
            </AppBar>
            <TabPanel value={ value } index={ 0 }>
              <ImportScreen userProfile={ props.userProfile } />
            </TabPanel>
            <TabPanel value={ value } index={ 1 }>
              <SurveyPreview userProfile={ props.userProfile } />
            </TabPanel>
            <TabPanel value={ value } index={ 2 }>
              <ReviewIframe />
            </TabPanel>
          </>
        ) : (
          <>
            <AppBar position="static">
              <Tabs
                value={ value }
                onChange={ handleChange }
                aria-label="Questionários"
              >
                <Tab label="Questionário" />
              </Tabs>
            </AppBar>
            <TabPanel value={ value } index={ 0 }>
              <SurveyPreview userProfile={ props.userProfile } />
            </TabPanel>
            <TabPanel value={ value } index={ 1 }>
              <ReviewIframe />
            </TabPanel>
          </>
        )
    }
    </>
  )
}
